// extracted by mini-css-extract-plugin
export var navbarSubLink = "B_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "B_tp d_f0 d_dB";
export var subPageLink = "B_gf d_gf";
export var burger = "B_t7";
export var sublinkSize = "B_t8";
export var linkSize = "B_t9";
export var Link = "B_rz q_rz q_qN q_q6";